import {SET_DATA,SET_TAB_INDEX} from "./types";
const mutations = {
  [SET_DATA](state, params) {
    state.params = params;
  },
  [SET_TAB_INDEX](state, tabindex) {
    state.params.TabNavIndex = tabindex;
    state.TabNavIndex = tabindex;
  }
}


export default {
  ...mutations
};




// WEBPACK FOOTER //
// ./src/store/mutations.js